// extracted by mini-css-extract-plugin
module.exports = {"logo":"SectionIntro_logo__O97Wx","sectionIntro__container":"SectionIntro_sectionIntro__container__jyqW6"};